import React from "react";
import { Link } from "react-router-dom";
import NotFoundImage from "../../Assets/404.gif";
import NotFoundImageBlue from "../../Assets/404_blue.svg";

const PageError = ({ pageError }) => {
  return (
    <>
      {/* <div className="fix d-flex flex-column justify-content-center align-items-center text-center">
        <img src={NotFoundImage} className="responsive-image"></img>
        <h4 className="server_error">
          {pageError?.ErrorName}
        </h4>
        <p className="error_description">{pageError?.ErrorDesription}</p>
        <Link className="back-to-home-btn" to={pageError?.url}>
          {pageError?.buttonText}
        </Link>
      </div> */}

      {/* Blue design for 404*/}

      <div className="fix d-flex flex-column justify-content-center align-items-center text-center px-4">
        <img src={NotFoundImageBlue} className="responsive-image"></img>
        <div className="error-text-500">{pageError?.StatusCode}</div>
        <h4 className="server_error">
          {pageError?.ErrorName}
        </h4>
        <p className="error_description">{pageError?.ErrorDesription}</p>
        <Link className="back-to-home-btn" to={pageError?.url}>
          {pageError?.buttonText}
        </Link>
      </div>


      {/* <div className="authincation fix justify-content-center align-items-center">
        <div className="text-center col-md-5">
          <h1 className="error-text-500">{pageError?.StatusCode}</h1>
          <h4 className="server_error">
            <i className="fa fa-times-circle text-danger"></i>
            {pageError?.ErrorName}
          </h4>
          <p className="error_description">{pageError?.ErrorDesription}</p>
          <div>
            <Link className="back-to-home-btn " to={pageError?.url}>
              {pageError?.buttonText}
            </Link>
          </div>
        </div>
      </div>
         */}
    </>
  );
};

export default PageError;
